import * as React from 'react';
import './Loader.scss';

export function Loader() {
  return (
    <div className="rp-loader">
      <div className="loader" />
    </div>
  );
}
